



//funzione per l'addtocart del quickshop 
/*document.addEventListener("DOMContentLoaded", function () {
  
    const sizeOptions = document.querySelectorAll('.size-option');
    console.log("Numero di elementi .size-option trovati:", sizeOptions.length);
  
    sizeOptions.forEach(option => {
      console.log("Aggiungendo listener all'elemento:", option);
        option.addEventListener('click', function () {
          console.log("Elemento cliccato:", option);
            if (!option.classList.contains('no-disp')) {
                const variantId = option.getAttribute('data-variant-id');
                  console.log("Variant ID trovato:", variantId);
                addToCartAndUpdateDrawer(variantId);
                console.log("Funzione addToCartAndUpdateDrawer chiamata con Variant ID:", variantId);
            } else {
                alert("This size is currently unavailable.");
            }
        });
    });*/
document.addEventListener("DOMContentLoaded", function () {
    // Usa il delegation pattern per intercettare i click sugli elementi .size-option
    document.body.addEventListener('click', function (event) {
        if (event.target.classList.contains('size-option')) {
            const option = event.target;
            if (!option.classList.contains('no-disp')) {
                const variantId = option.getAttribute('data-variant-id');
                addToCartAndUpdateDrawer(variantId);
            } else {
                alert("This size is currently unavailable.");
            }
        }
    });

 function addToCartAndUpdateDrawer(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add item to cart');
        }
        return response.json();
    })
    .then(data => {
        console.log('Product added:', data);

        // Aggiorna il carrello
        return updateCartDrawer();
    })
    .then(() => {
        // Cerca l'elemento con ID specificato e rimuovi la classe is-empty
        const cartDrawerElement = document.querySelector('.drawer--cart');

        if (cartDrawerElement) {
            // Verifica se la classe is-empty esiste prima di rimuoverla
            if (cartDrawerElement.classList.contains('is-empty')) {
                cartDrawerElement.classList.remove('is-empty'); // Rimuovi is-empty
                console.log('is-empty class removed');
            }
            console.log('Current classes:', cartDrawerElement.classList);
        } else {
            console.warn('Element with ID cart-drawer not found');
        }

        triggerCartDrawerOpen(); // Apri il drawer
    })
    .catch((error) => {
        console.error('Error adding to cart:', error);
    });
}

function updateCartDrawer() {
    return fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
            let cartDrawer = document.getElementById('shopify-section-sections--21992725971290__cart-drawer');

            if (cartDrawer) {
                let itemsHolder = cartDrawer.querySelector('.drawer__items');

                if (!itemsHolder) {
                    itemsHolder = document.createElement('div');
                    itemsHolder.classList.add('drawer__items');
                    cartDrawer.appendChild(itemsHolder);
                }

                itemsHolder.innerHTML = '';

                // Verifica se il carrello è vuoto
                if (cart.items.length === 0) {
                    itemsHolder.innerHTML = '<p>Il carrello è vuoto</p>';
                    cartDrawer.classList.add('is-empty'); // Aggiungi classe is-empty
                    console.log('is-empty class added');
                } else {
                    cartDrawer.classList.remove('is-empty'); // Rimuovi classe se non vuoto
                    console.log('Cart is not empty, removing is-empty class');
                    cart.items.forEach((item, index) => {
                        const itemDiv = createCartItemElement(item, index);
                        itemsHolder.appendChild(itemDiv);
                    });
                }

                setupQuantityChangeListeners(itemsHolder);
            } else {
                console.warn('Element with ID cart-drawer not found in updateCartDrawer');
            }

            updateCartSubtotal(cart.total_price);
            updateCartCount(cart.item_count);
            hideCartError();
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
}





  function triggerCartDrawerOpen() {
 //   const cartDrawerElement = document.getElementById('shopify-section-sections--21992725971290__cart-drawer');
      const cartDrawerElement = document.getElementById('cart-drawer');
   
    if (cartDrawerElement) {
        // Se il drawer deve mostrare modifiche nel DOM o attivare una classe CSS:
        cartDrawerElement.classList.add('is-open'); // Supponendo che questa sia la classe che apre il drawer

        // Se utilizzi un evento per aprire il drawer:
        const event = new CustomEvent('theme:cart-drawer:open', { bubbles: true });
        document.dispatchEvent(event);
    }
}




function removeFromCart(line) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to remove item from cart');
        }
        updateCartDrawer(); // This updates the cart data and cart count
    })
    .catch((error) => {
        console.error('Error removing item from cart:', error);
    });
}


    function createCartItemElement(item, index) {
        const itemDiv = document.createElement('div');
        itemDiv.classList.add('cart__item', 'is-animated');
        itemDiv.setAttribute('data-item', `${item.id}:${item.key}`);
        itemDiv.setAttribute('data-item-index', index + 1);
        itemDiv.setAttribute('data-item-title', `${item.product_title} - ${item.variant_title}`);
        itemDiv.innerHTML = `
            <div class="cart__item__image">
                <a href="${item.url}" aria-label="${item.product_title} - ${item.variant_title}" data-samitapbl-handle="${item.handle}">
                    <div class="lazy-image">
                        <img src="${item.image}" alt="${item.product_title}" srcset="${item.image} 90w, ${item.image} 180w" width="180" height="270" loading="lazy" sizes="90px" class="">
                    </div>
                </a>
            </div>
            <div class="cart__item__content">
                <div class="cart__item__content-inner">
                    <h4 class="cart__item__title">
                        <a href="${item.url}" data-samitapbl-handle="${item.handle}">${item.product_title}</a>
                    </h4>
                    <div class="cart__item__meta">
                        <p class="cart__item__selected-options"><strong>Size:</strong><span>${item.variant_title}</span></p>
                    </div>
                </div>
                <p class="cart__price">€${(item.price / 100).toFixed(2)}</p>
                <quantity-counter class="cart__quantity-counter">
                    <div class="cart__quantity">
                        <button class="cart__quantity-minus" type="button" name="decrease"
                                title="Decrease quantity - ${item.product_title}">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 24 24">
                                <path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </button>
                        <input class="cart__quantity-field" type="number" id="updates_${item.id}:${item.key}" 
                               name="updates[]" data-id="${item.id}:${item.key}" value="${item.quantity}" 
                               title="Quantity field - ${item.product_title}" pattern="[0-9]*">
                        <button class="cart__quantity-plus" type="button" name="increase" 
                                title="Increase quantity - ${item.product_title}">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24">
                                <path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </button>
                    </div>
                    <a class="cart__item__remove" href="#" data-item-remove=""
                       data-id="${item.id}:${item.key}" title="Rimuovi" onclick="removeFromCart(${index + 1}); return false;">
                        Rimuovi
                    </a>
                </quantity-counter>
            </div>
        `;
        return itemDiv;
    }

  


    function changeQuantity(line, delta) {
        const input = document.querySelector(`.cart__quantity-field[data-item-index="${line}"]`);
        if (input) {
            let quantity = parseInt(input.value, 10);
            if (!isNaN(quantity) && quantity + delta > 0) {
                input.value = quantity + delta;
                updateCartItem(line, quantity + delta);
            }
        }
    }
    

  

// Define this function so it's in global scope
window.removeFromCart = function(line) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ line: line, quantity: 0 })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to remove item from cart');
            }
            updateCartDrawer(); // Refresh the drawer with updated cart data
        })
        .catch((error) => {
            console.error('Error removing item from cart:', error);
        });
    };
function setupQuantityChangeListeners(container) {
    container.querySelectorAll('.cart__quantity-plus').forEach(button => {
        button.addEventListener('click', function () {
            const line = button.closest('.cart__item').getAttribute('data-item-index');
            const input = button.closest('.cart__quantity-counter').querySelector('.cart__quantity-field');
            const originalValue = parseInt(input.value, 10); // Memorizza il valore originale

            changeQuantity(line, 1, input, originalValue);
        });
    });

    container.querySelectorAll('.cart__quantity-minus').forEach(button => {
        button.addEventListener('click', function () {
            const line = button.closest('.cart__item').getAttribute('data-item-index');
            const input = button.closest('.cart__quantity-counter').querySelector('.cart__quantity-field');
            const originalValue = parseInt(input.value, 10); // Memorizza il valore originale

            changeQuantity(line, -1, input, originalValue);
        });
    });

    container.querySelectorAll('.cart__quantity-field').forEach(input => {
        input.addEventListener('focus', function () {
            this.dataset.originalValue = this.value; // Memorizza il valore originale quando l'input è a fuoco
        });

        input.addEventListener('change', function () {
            const line = input.closest('.cart__item').getAttribute('data-item-index');
            const quantity = parseInt(input.value, 10);
            const originalValue = this.dataset.originalValue; // Usa il valore memorizzato

            if (!isNaN(quantity) && quantity > 0) {
                updateCartItem(line, quantity, originalValue);
            } else {
                input.value = originalValue; // Ritorna al valore originale se non valido
            }
        });
    });
}
function updateCartItem(line, quantity, originalValue) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ line: parseInt(line), quantity: quantity })
    })
    .then(response => {
        if (!response.ok) {
            // Se la risposta non è ok, gestire l'errore
            return response.json().then(data => {
                throw new Error(data.description || 'Errore nell\'aggiornamento dell\'articolo nel carrello.');
            });
        }
        return response.json(); // Restituisce la risposta JSON se tutto è andato bene
    })
    .then(cartData => {
        updateCartDrawer(); // Aggiorna il carrello se tutto ha funzionato
        console.log(`Successfully updated item at line: ${line} to quantity: ${quantity}`);
    })
    .catch(error => {
        const input = document.querySelector(`.cart__item[data-item-index="${line}"] .cart__quantity-field`);

        // Se l'input esiste, ripristina il valore originale
        if (input) {
            console.log(`Error occurred: ${error.message}. Restoring original value: ${originalValue}`);
            input.value = originalValue; // Ripristina il valore originale
        }

        console.error('Error updating cart item:', error.message);
        showCartError(error.message); // Mostra un errore all'utente
    });
}
function showCartError(message) {
    const errorContainer = document.querySelector('[data-cart-errors]');
    if (errorContainer) {
        errorContainer.classList.add('is-expanded');
        errorContainer.querySelector('[data-error-message]').innerText = message;
    }
}

function hideCartError() {
    const errorContainer = document.querySelector('[data-cart-errors]');
    if (errorContainer) {
        errorContainer.classList.remove('is-expanded');
    }
}
//aggiorno il contatore
function updateCartCount(newCount) {
    const cartCountElement = document.querySelector('.cart__items-count');
    if (cartCountElement) {
        cartCountElement.setAttribute('data-cart-count', newCount);
        cartCountElement.innerText = newCount;
    }
}
  //aggiorno il sub totale
function updateCartSubtotal(newSubtotal) {
    const cartSubtotalElement = document.querySelector('.cart__total__price');
    if (cartSubtotalElement) {
        cartSubtotalElement.setAttribute('data-cart-total', newSubtotal); 
        cartSubtotalElement.innerText = `€${(newSubtotal / 100).toFixed(2)}`; // Convert cents to euros
    }
}




});
document.addEventListener("DOMContentLoaded", function () {
    // Assicurati di avere lo stesso selettore per il pulsante di chiusura
    const closeButton = document.querySelector('.drawer__close[data-cart-drawer-close]');

    if (closeButton) {
        closeButton.addEventListener('click', function () {
           // const cartDrawerElement = document.getElementById('shopify-section-sections--21992725971290__cart-drawer');
           const cartDrawerElement = document.getElementById('cart-drawer');
            if (cartDrawerElement) {
                cartDrawerElement.classList.remove('is-open'); // Rimuovi la classe che rende visibile il drawer
            }
        });
    }
  
});




document.addEventListener('DOMContentLoaded', function() {
  //const drawer = document.getElementById('shopify-section-sections--21992725971290__cart-drawer');
  const drawer = document.getElementById('cart-drawer');
  const underlay = document.querySelector('.underlay');

  if (underlay) {
    underlay.addEventListener('click', function() {
      drawer.classList.remove('is-open'); // Rimuove la classe per chiudere il drawer
    });
  }
});

//verifica delle quantità nel minicart
document.addEventListener("DOMContentLoaded", function () {
    // Evento di apertura carrello, memorizza i valori originali
    const openButton = document.querySelector('.cart-drawer-open');
    if (openButton) {
        openButton.addEventListener('click', function () {
            storeOriginalValues();
            triggerCartDrawerOpen();
        });
    }

    // Chiudi il carrello
    const closeButton = document.querySelector('.drawer__close[data-cart-drawer-close]');
    if (closeButton) {
        closeButton.addEventListener('click', function () {
           // const cartDrawerElement = document.getElementById('shopify-section-sections--21992725971290__cart-drawer');
           const cartDrawerElement = document.getElementById('cart-drawer');
            if (cartDrawerElement) {
                cartDrawerElement.classList.remove('is-open');
            }
        });
    }
});

// Memorizza i valori originali appena il drawer si apre
function storeOriginalValues() {
    const quantityFields = document.querySelectorAll('.cart__quantity-field');
    quantityFields.forEach(input => {
        const quantityValue = input.value || '0';
        input.setAttribute('data-original-value', quantityValue); // Store the current value
        const itemIndex = input.closest('.cart__item') ? input.closest('.cart__item').getAttribute('data-item-index') : 'none';
        console.log(`Stored Original Value for Item Index ${itemIndex}: ${quantityValue}`);
    });
}

function setupQuantityChangeListeners(container) {
    container.querySelectorAll('.cart__quantity-plus').forEach(button => {
        button.addEventListener('click', function () {
            const line = button.closest('.cart__item').getAttribute('data-item-index');
            const input = button.closest('.cart__quantity-counter').querySelector('.cart__quantity-field');
            const originalValue = parseInt(input.getAttribute('data-original-value'), 10);

            changeQuantity(line, 1, input, originalValue);
        });
    });

    container.querySelectorAll('.cart__quantity-minus').forEach(button => {
        button.addEventListener('click', function () {
            const line = button.closest('.cart__item').getAttribute('data-item-index');
            const input = button.closest('.cart__quantity-counter').querySelector('.cart__quantity-field');
            const originalValue = parseInt(input.getAttribute('data-original-value'), 10);

            changeQuantity(line, -1, input, originalValue);
        });
    });

    container.querySelectorAll('.cart__quantity-field').forEach(input => {
        input.addEventListener('change', function () {
            const line = input.closest('.cart__item').getAttribute('data-item-index');
            const quantity = parseInt(input.value, 10);
            const originalValue = parseInt(input.getAttribute('data-original-value'), 10);

            console.log(`On Change - Line: ${line}, Original Value: ${originalValue}, Changed Value: ${quantity}`);

            if (!isNaN(quantity) && quantity > 0) {
                checkAvailabilityAndUpdate(line, quantity, originalValue, input);
            } else {
                console.warn(`Invalid quantity. Restoring original value: ${originalValue}`);
                input.value = originalValue;
            }
        });
    });
}

function checkAvailabilityAndUpdate(line, quantity, originalValue, input) {
    // Simulating availability check; replace with actual API call
    fetch(`/product/check-availability?item_id=${line}&quantity=${quantity}`)
        .then(response => response.json())
        .then(data => {
            if (data.isAvailable) {
                updateCartItem(line, quantity, originalValue);
            } else {
                alert('La quantità desiderata non è disponibile. Ripristinando il valore originale.');
                input.value = originalValue;
            }
        })
        .catch(error => {
            console.error('Errore nel controllo della disponibilità:', error);
            alert('Errore nel controllo della disponibilità. Ripristinando il valore originale.');
            input.value = originalValue;
        });
}

function changeQuantity(line, delta, input, originalValue) {
    let quantity = parseInt(input.value, 10);
    if (!isNaN(quantity) && quantity + delta > 0) {
        input.value = quantity + delta;
        checkAvailabilityAndUpdate(line, quantity + delta, originalValue, input);
    }
}

function triggerCartDrawerOpen() {
  //  const cartDrawerElement = document.getElementById('shopify-section-sections--21992725971290__cart-drawer');
  const cartDrawerElement = document.getElementById('cart-drawer');
    if (cartDrawerElement) {
        cartDrawerElement.classList.add('is-open');
        const event = new CustomEvent('theme:cart-drawer:open', { bubbles: true });
        document.dispatchEvent(event);
    }
}

// Funzione di aggiornamento articolo carrello (contenente il tuo codice di aggiornamento)
function updateCartItem(line, quantity, originalValue) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ line: parseInt(line), quantity: quantity })
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => {
                throw new Error(data.description || 'Errore nell\'aggiornamento dell\'articolo nel carrello.');
            });
        }
        return response.json();
    })
    .then(cartData => {
        updateCartDrawer(); // Refresh cart UI
        console.log(`Successfully updated item at line: ${line} to quantity: ${quantity}`);
    })
    .catch(error => {
        console.error('Error updating cart item:', error.message);
        showCartError(error.message);
        input.value = originalValue; // Restore original quantity on error
    });
}

function updateCartDrawer() {
    // Invoca la logica per aggiornare il drawer del carrello
    // Aggiorna UI, gestione dei totali e conteggi del carrello
}

function showCartError(message) {
    const errorContainer = document.querySelector('[data-cart-errors]');
    if (errorContainer) {
        errorContainer.classList.add('is-expanded');
        errorContainer.querySelector('[data-error-message]').innerText = message;
    }
}

function hideCartError() {
    const errorContainer = document.querySelector('[data-cart-errors]');
    if (errorContainer) {
        errorContainer.classList.remove('is-expanded');
    }
}

//aggiorno il contatore nell'icona del carrello
document.addEventListener('DOMContentLoaded', function() {
  // Seleziona tutte le opzioni di taglia
  const sizeOptions = document.querySelectorAll('.size-option');

  // Aggiunge un gestore di eventi di clic a ciascuna opzione di taglia
  sizeOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      // Aggiorna il contatore del carrello
      updateCartCount();
    });
  });

  function updateCartCount() {
    const cartStatusElement = document.querySelector('.header__desktop .header__cart__status');
    let currentCount = parseInt(cartStatusElement.textContent) || 0;
    currentCount += 1; // Incrementa il contatore

    // Aggiorna il contatore nel badge del carrello
    cartStatusElement.textContent = currentCount;

    // Mostra il badge se è nascosto
    if (cartStatusElement.style.display === 'none' || !cartStatusElement.style.display) {
      cartStatusElement.style.display = 'flex'; // O il valore che usi per visualizzarlo
    }
  }
});





document.addEventListener("DOMContentLoaded", function () {
    // Usa il delegation pattern per intercettare i click sugli elementi '#backtoshop'
    document.body.addEventListener('click', function (event) {
        console.log('Elemento cliccato:', event.target); // Log per debug
        if (event.target.id === 'backtoshop') {
            console.log('Elemento con ID "backtoshop" cliccato'); // Log per debug
            const closeButton = event.target;
            const cartDrawerElement = document.getElementById('cart-drawer');
            if (cartDrawerElement) {
                cartDrawerElement.classList.remove('is-open'); // Rimuovi la classe che rende visibile il drawer
                console.log('Drawer del carrello chiuso'); // Log per debug
            }
          // Rimuove gli stili inline dal body
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('padding-right');
        }
    });
});
